import { render, staticRenderFns } from "./OfflinePage.vue?vue&type=template&id=95ef1058&"
import script from "./OfflinePage.vue?vue&type=script&lang=js&"
export * from "./OfflinePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports